import { CUSTOM_ELEMENTS_SCHEMA, Component, ViewEncapsulation, input, output } from '@angular/core';

import '@asn/icon';

import { ListItemActionType } from '../list-item.model';

@Component({
    selector: 'ap-list-item-link',
    templateUrl: './list-item-link.html',
    styleUrls: ['./list-item-link.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ApListItemLinkComponent {
    /**
     * Eventemitter that is emitted on click, keyboard enter and keyboard space
     */
    public readonly itemClicked = output<void>();

    public readonly actionType = input<Partial<ListItemActionType>>();

    public readonly disabled = input(false);

    protected getTabIndex(): number {
        const actionType = this.actionType();
        return actionType === 'internalLink' || actionType === 'externalLink' ? 0 : null;
    }

    protected getActionIcon(): string | null {
        const actionType = this.actionType();
        if (actionType === 'internalLink') {
            return 'chevron-right';
        } else if (actionType === 'externalLink') {
            return 'external-link';
        }
        return null;
    }

    protected onItemClicked(): void {
        this.itemClicked.emit(undefined);
    }
}
